/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ connection: NonNullable<unknown> }} Audit_Details_Tool_Connection_Unlinked_DescInputs */



/**
* | output |
* | --- |
* | "Tool connection unlinked: {connection}. Its tools are no longer available in that project." |
*
* @param {Audit_Details_Tool_Connection_Unlinked_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_tool_connection_unlinked_desc = /** @type {((inputs: Audit_Details_Tool_Connection_Unlinked_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Tool_Connection_Unlinked_DescInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Tool-Verbindung getrennt: ${i?.connection}. Ihre Tools sind in diesem Projekt nicht mehr verfügbar.`)
	return /** @type {LocalizedString} */ (`Tool connection unlinked: ${i?.connection}. Its tools are no longer available in that project.`)
});